import {
    ModalContent,
    ModalFooter,
    ModalHeader,
} from '../ModalView'
import Button from 'components/Button'
import {HeroExclamationTriangleIcon} from 'components/Icon'
import {Icon} from 'components/Icon/types'
import Modal from '../Modal'
import React from 'react'
import {SetTranscriptStatusModalProps} from './types'
import {theme} from 'stitches/config'
import {useTranslation} from 'react-i18next'

const SetTranscriptStatusPromiseModalView = (props: SetTranscriptStatusModalProps): React.ReactElement => {
    const {
        onResolve, onReject,
    } = props

    const {t} = useTranslation()

    const handleSubmitModal = () => {
        // eslint-disable-next-line no-unused-expressions
        onResolve && onResolve()
    }

    const handleCloseModal = () => {
        // eslint-disable-next-line no-unused-expressions
        onReject && onReject()
    }

    return (
        <Modal onClose={handleCloseModal} zIndex={theme.zIndices.modalHighPriority.value}>
            <ModalHeader icon={HeroExclamationTriangleIcon as unknown as Icon} title={t('Do you wish to close the ticket?')} type='error' />
            <ModalContent>
                <p>{t('The ticket is marked as done and will be closed.')}</p>
            </ModalContent>
            <ModalFooter>
                <Button onPress={handleCloseModal} tabIndex={-1} text={t('Cancel')} />
                <Button color='filled' margin='left' onPress={handleSubmitModal} tabIndex={0} text={t('Close')} />
            </ModalFooter>
        </Modal>
    )
}

export default SetTranscriptStatusPromiseModalView
